import React, {Component} from 'react';
import ReactGoogleMapLoader from 'react-google-maps-loader'
import ReactGoogleMap from 'react-google-map'

export default class Map extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <ReactGoogleMapLoader
        params={{
          key: 'AIzaSyBmeZA4ivQs0VB_JfIyozmerRhNMnyz3Xw',
          region: 'JP',
        }}
        // params={{
        //   client: 'gme-mazdamotorcorporation1',
        //   signature: 'QbXS0wAebJscLvYZZ688gKHTkkw='
        // }}
        // params={{
        //   key: this.props.apiKey,
        // }}
        style={this.props.style}
        render={googleMaps => {
          return (
            googleMaps && (
              <ReactGoogleMap
                googleMaps={googleMaps}
                coordinates={this.props.coordinates}
                center={this.props.center}
                zoom={this.props.zoom}
              />
            )
          )
        }}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/map/index.jsx